
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Label } from '@/components/ui/label';
import { SORT_OPTIONS } from '../utils/filterUtils';

interface SortByFilterProps {
  value: string;
  onChange: (value: string) => void;
}

export const SortByFilter = ({ value, onChange }: SortByFilterProps) => {
  const handleOnChange = (newValue: string) => {
    if (typeof onChange === 'function') {
      onChange(newValue);
    }
  };

  return (
    <div>
      <Label className="text-sm font-medium mb-2 block">Sort By</Label>
      <Select 
        value={value || ''} 
        onValueChange={handleOnChange}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Select sorting option" />
        </SelectTrigger>
        <SelectContent>
          {SORT_OPTIONS.map((option) => (
            <SelectItem key={option} value={option.toLowerCase()}>
              {option}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
